class Tableau {
	constructor() {
		this.init();
	}

	init() {
		this.gestionTailleTableau();
		window.addEventListener("resize", () => {
			this.gestionTailleTableau();
		});
	}

	//gestion taille tableau pour que le bloc mis en avant sois toujours le plus grand, même au resize
	gestionTailleTableau() {
		let tableauBloc = document.querySelectorAll(".tableau-list");
		for (var i = 0; i < tableauBloc.length; i++) {
			let tableauList = tableauBloc[i].querySelectorAll(".tableau-single__item");
			var maxHeight = 0;
			for (var j = 0; j < tableauList.length; j++) {
				if (tableauList[j].offsetHeight > maxHeight) {
					if (tableauList[j].classList.contains("is-active")) {
						maxHeight = tableauList[j].offsetHeight;
					} else {
						maxHeight = tableauList[j].offsetHeight + 30;
					}
				}
			}

			var finalHeight = maxHeight + "px";
			var cibles = tableauBloc[i].querySelectorAll(".tableau-single__item.is-active");
			for (var k = 0; k < cibles.length; k++) {
				cibles[k].style.minHeight = finalHeight;
			}
		}
	}
}
